import React from 'react';
import { TreatmentsSection } from '../components/TreatmentsSection';
import { ProcessSection } from '../components/ProcessSection';
export function Treatments() {
  return <div data-id="element-1333">
      <TreatmentsSection data-id="element-1334" />
      <ProcessSection data-id="element-1335" />
    </div>;
}